export default "__VITE_ASSET__p5ENa7TB__"